<template>
    <div v-if="showRating">
        <!-- Rain stripes -->
        <div v-if="rainActive" class="rain-layer">
      <span
          v-for="(stripe,i) in rainStripes"
          :key="i"
          class="rain-stripe"
          :style="{
          left: stripe.leftPct + '%',
          '--dur': stripe.durMs + 'ms',
          '--delay': stripe.delayMs + 'ms',
          width: stripe.width + 'px',
          height: stripe.height + 'px'
        }"
      />
        </div>

        <!-- Floating Button -->
        <div v-if="isMinimized" class="floating-btn" @click="restoreFromFloat">
            <img
                width="24px"
                style="cursor: pointer; filter: drop-shadow(2px 0px 2px #3d3737)"
                :src="require('@/assets/images/starRat.svg')"
            />
        </div>

        <!-- Custom Dialog -->
        <transition name="el-fade-in" :duration="2000">
            <div v-show="visible" class="custom-dialog">
                <!-- Header -->
                <div class="dialog-header">
                    <div class="left">
                        <div class="icon-badge">
                            <img :src="require('@/assets/images/ic-feeling.svg')" alt="" />
                        </div>
                        <div>
                            <div style="font-weight: 700; font-size: 16px">Gửi đánh giá của bạn</div>
                            <div style="color: #6b7280; font-size: 12px">
                                Đội dự án rất mong nhận được phản hồi từ đồng chí!
                            </div>
                        </div>
                    </div>
                    <div style="display: flex; gap: 10px">
                        <el-tooltip content="Thu nhỏ" placement="bottom">
                            <div class="btn-action" @click="minimize">
                                <i class="el-icon-minus"></i>
                            </div>
                        </el-tooltip>
                        <el-tooltip content="Đóng" placement="bottom">
                            <div class="btn-action" @click="closeAll">
                                <i class="el-icon-close"></i>
                            </div>
                        </el-tooltip>
                    </div>
                </div>

                <!-- Body -->
                <el-form ref="formRef" :model="form" :rules="rulesDynamic" label-position="top">
                    <div v-for="(q, idx) in questions" :key="q.questionId">
                        <el-form-item
                            v-if="q.answer_type === 'rating'"
                            :prop="'dynamic.' + idx + '.value_rating'"
                        >
                            <div style="font-style: italic; line-height: 2rem">{{ q.question }}</div>

                            <div class="rate-row" @mouseleave="onRateLeave(idx)">
                                <el-rate
                                    v-model="form.dynamic[idx].value_rating"
                                    :max="5"
                                    @mousemove.native="onRateHover(idx, $event)"
                                    @change="onRateSelect(idx)"
                                />
                                <div class="rate-caption">
                                    <img
                                        v-if="currentIcon(idx)"
                                        :src="currentIcon(idx)"
                                        alt=""
                                        :class="['rate-icon', iconClass(idx)]"
                                    />
                                    <span class="rate-text">{{ displayText(idx) }}</span>
                                </div>
                            </div>
                        </el-form-item>
                    </div>

                    <div style="display: flex; gap: 10px; justify-content: flex-end; flex-wrap: wrap">
                        <el-button class="submit-rate" type="primary" :loading="submitting" @click="onSubmit()">
                            Gửi đánh giá
                        </el-button>
                    </div>
                </el-form>
            </div>
        </transition>

        <!-- Dialog góp ý khi chọn 1-3 sao -->
        <CryDialog
            :visible="showLowDialog"
            @closeRateLow="handleCloseRatingLow"
            @confirm="handleSubmitLowRating"
        />

        <!-- Mưa icon 'khóc' (1-3 sao) -->
        <div v-show="cryRainActive" class="cry-rain" aria-hidden="true">
      <span
          v-for="(drop, i) in cryRainItems"
          :key="i"
          class="cry-drop"
          :style="{
          left: drop.leftPct + '%',
          '--dur': drop.durMs + 'ms',
          '--sway': drop.swayMs + 'ms',
          animationDelay: drop.delayMs + 'ms',
          fontSize: drop.sizePx + 'px'
        }"
      >😭</span>
        </div>

        <!-- Canvas pháo hoa + confetti (4-5 sao) -->
        <canvas v-show="fireworksActive" ref="fireCanvas" class="fireworks-canvas"></canvas>
    </div>
</template>

<script>
import { checkSurvey, getQuestion, submitSurvey } from "@/services/RatingService";
import CryDialog from "./CryDialog.vue";

export default {
    name: "Rating",
    components: { CryDialog },
    data() {
        return {
            // timers
            _ratingDelayTimer: null,
            _ratingAutoHideTimer: null,
            _rainTimer: null,

            showLowDialog: false,
            showRating: false,   // root v-if -> unmount khi false
            visible: true,       // ẩn/hiện form (không unmount)
            isMinimized: false,
            submitting: false,

            // effects toggle
            screenFlash: false,
            rainActive: false,

            rateTexts: ["Rất tệ", "Kém", "Bình thường", "Tốt", "Tuyệt vời"],

            form: {
                ticket: "",
                surveyId: "",
                dynamic: [],
                answerList: []
            },

            rulesDynamic: {},
            hoverRating: 0,

            ratingIcons: {
                1: require("@/assets/images/rating-1.svg"),
                2: require("@/assets/images/rating-2.svg"),
                3: require("@/assets/images/rating-3.svg"),
                4: require("@/assets/images/rating-4.svg"),
                5: require("@/assets/images/rating-5.svg")
            },

            questions: [],

            // ==== EFFECT STATES ====
            // rain stripes
            rainStripes: [],

            // crying rain
            cryRainActive: false,
            cryRainItems: [],

            // fireworks
            fireworksActive: false,
            _fwAnim: null,
            _fwEndTimer: null,
            _fwResizeHandler: null,
            _confettiEnabled: false,
            _fwResolve: null,          // <- Promise resolver khi pháo hoa kết thúc

            // stores
            fwParticles: [],
            confetti: []
        };
    },

    mounted() {
        this.checkShowRating();
    },

    beforeDestroy() {
        if (this._fwAnim) cancelAnimationFrame(this._fwAnim);
        if (this._fwResizeHandler) window.removeEventListener("resize", this._fwResizeHandler);
        clearTimeout(this._fwEndTimer);
        clearTimeout(this._ratingDelayTimer);
        clearTimeout(this._ratingAutoHideTimer);
        clearTimeout(this._rainTimer);
    },

    methods: {
        /* ====== Basic ====== */
        handleCloseRatingLow(isSubmit) {
            this.showLowDialog = false;
            if (isSubmit) this.onSubmit(false);
            else this.visible = true;
        },
        hasLowRatings() {
            return this.form.dynamic.some((item, idx) => {
                if (this.questions[idx]?.answer_type !== "rating") return false;
                const v = Number(item?.value_rating || 0);
                return v >= 1 && v <= 3;
            });
        },
        displayText(idx) {
            const item = this.form.dynamic[idx] || {};
            const v = item._hoverRating || item.value_rating || 0;
            return this.rateTexts[v - 1] || "";
        },
        onRateHover(idx, e) {
            const item = this.form.dynamic[idx] || {};
            const icons = e.currentTarget.querySelectorAll(".el-rate__item");
            const starIdx = Array.from(icons).findIndex(i => i.contains(e.target));
            if (starIdx >= 0) this.$set(item, "_hoverRating", starIdx + 1);
        },
        onRateLeave(idx) {
            const item = this.form.dynamic[idx] || {};
            this.$set(item, "_hoverRating", 0);
        },
        currentIcon(idx) {
            const item = this.form.dynamic[idx] || {};
            const val = item._hoverRating || item.value_rating || 0;
            return this.ratingIcons[val] || this.ratingIcons[3];
        },
        iconClass(idx) {
            const item = this.form.dynamic[idx] || {};
            const v = item._hoverRating || item.value_rating || 0;
            const base = v > 0 && v <= 2 ? "anim-shake" : v >= 4 ? "anim-bounce" : "";
            return [base, item._justChanged ? "anim-pop-once" : ""].filter(Boolean).join(" ");
        },
        onRateSelect(idx) {
            const item = this.form.dynamic[idx] || {};
            this.$set(item, "_justChanged", true);
            setTimeout(() => this.$set(item, "_justChanged", false), 300);

            const v = Number(this.form.dynamic[idx]?.value_rating || 0);
            if (v >= 1 && v <= 3) this.triggerCryingRain(v);
            else if (v >= 4) this.triggerFireworks(v); // hiển thị tức thì khi chọn 4-5
        },

        /* ====== Hiển thị theo mốc thời gian (2h-4h…) nếu bạn cần) ====== */
        checkShowRating() {
            const now = Date.now();
            const showAt = Number(localStorage.getItem("rating_show_at") || 0);
            const hideAt = Number(localStorage.getItem("rating_hide_at") || 0);

            if (now < showAt) {
                const wait = showAt - now;
                clearTimeout(this._ratingDelayTimer);
                this._ratingDelayTimer = setTimeout(() => this.callApiCheckRating(), wait);
                return;
            }
            if (hideAt && now >= hideAt) {
                this.showRating = false;
                this.visible = false;
                this.isMinimized = false;
                return;
            }
            this.callApiCheckRating();
            if (hideAt) {
                const remain = hideAt - now;
                clearTimeout(this._ratingAutoHideTimer);
                this._ratingAutoHideTimer = setTimeout(() => {
                    this.showRating = false;
                    this.visible = false;
                    this.isMinimized = false;
                }, remain);
            }
        },

        async callApiCheckRating() {
            try {
                let showRate = await checkSurvey();
                if (!showRate) {
                    localStorage.setItem("ignore_rating", true);
                    return;
                }
                const res = await getQuestion();
                this.questions = Array.isArray(res.data) ? res.data : (res.data?.data || []);
                if (this.questions.length === 0) {
                    this.showRating = false;
                    return;
                }
                this.showRating = true;
                this.buildDynamicModelAndRules(this.questions);
            } catch (e) {
                console.error(e);
            }
        },

        /* ====== Build dynamic model an toàn ====== */
        parseKeyAnswers(q) {
            return (q.keyAnswers || "")
                .split(",")
                .map(s => s.trim())
                .filter(Boolean)
                .map(item => {
                    const idx = item.indexOf("=");
                    if (idx === -1) return { key: item, defaultValue: null };
                    const key = item.slice(0, idx).trim();
                    const raw = item.slice(idx + 1).trim();
                    return { key, defaultValue: this.parseDefault(raw) };
                });
        },
        parseDefault(val) {
            if (/^-?\d+(\.\d+)?$/.test(val)) return Number(val);
            const low = String(val).toLowerCase();
            if (low === "true") return true;
            if (low === "false") return false;
            return val;
        },

        buildDynamicModelAndRules(questions) {
            this.form.dynamic = [];
            this.rulesDynamic = {};
            questions.forEach((q, idx) => {
                const parsed = this.parseKeyAnswers(q);
                let item = { questionId: q.questionId, answer_type: q.answer_type };

                if (parsed.length === 0) {
                    item.value = q.answer_type === "rating" ? 0 : "";
                } else {
                    parsed.forEach(({ key, defaultValue }) => {
                        let initVal = defaultValue;
                        if (initVal === null)
                            initVal = q.answer_type === "rating" && key === "value_rating" ? 0 : "";
                        item[key] = initVal;
                    });
                }
                this.form.dynamic.push(item);
                if (q.answer_type === "rating") {
                    const propPath = "dynamic." + idx + ".value_rating";
                    this.$set(this.rulesDynamic, propPath, [
                        { required: true, message: "Hãy chấm sao mức độ hài lòng", trigger: "change" }
                    ]);
                }
            });
        },

        /* ====== Dialog control ====== */
        minimize() { this.visible = false; this.isMinimized = true; },
        restoreFromFloat() { this.isMinimized = false; this.visible = true; },
        closeAll() { this.visible = false; this.isMinimized = false; },

        handleSubmitLowRating(val) {
            this.onSubmit(val);
            this.showLowDialog = val;
        },

        /* ====== Submit ====== */
        async onSubmit(checkLow = true) {
            this.$refs.formRef.validate(async (ok) => {
                if (!ok) return;
                if (this.hasLowRatings() && checkLow) {
                    this.visible = false;
                    this.showLowDialog = true;
                    this._stopFireworks(); // dọn hiệu ứng nếu có
                    return;
                }
                this.submitting = true;

                if (this.questions.length) {
                    this.form.ticket = localStorage.getItem("token_sso");
                    this.form.surveyId = this.questions[0].surveyId;
                }

                const now = new Date().toISOString();
                this.form.answerList = this.form.dynamic.map(item => {
                    const { questionId, answer_type, _hoverRating, _justChanged, ...answers } = item;
                    return { question_id: questionId, answer_type, create_date: now, ...answers };
                });

                const hasFiveStar = this.form.answerList.some(a => Number(a.value_rating) === 5);

                const formSubmit = {
                    ticket: this.form.ticket,
                    surveyId: this.form.surveyId,
                    answerList: this.form.answerList
                };

                try {
                    await submitSurvey(formSubmit);
                    this.$message({ type: "success", duration: 2000, message: "Đã gửi phản hồi! Cảm ơn bạn 🥰" });

                    if (hasFiveStar) {
                        // 1) Ẩn form NGAY để chỉ còn pháo hoa, nhưng KHÔNG unmount component
                        this.visible = false;       // ẩn dialog
                        this.isMinimized = false;   // đảm bảo không hiện mini btn
                        this.showRating = true;     // GIỮ MOUNT để canvas còn sống

                        // 2) Kích hoạt pháo hoa & CHỜ kết thúc
                        try {
                            await this.triggerFireworks(5); // returns a Promise, resolve khi _stopFireworks()
                        } finally {
                            // 3) Khi pháo hoa xong, unmount hoàn toàn
                            this.showRating = false;
                        }
                    } else {
                        // Không có 5 sao -> ẩn ngay & unmount
                        this._stopFireworks();
                        this.visible = false;
                        this.isMinimized = false;
                        this.showRating = false;
                    }
                } catch (e) {
                    // lỗi submit -> ẩn như cũ
                    this._stopFireworks();
                    this.visible = false;
                    this.isMinimized = false;
                    this.showRating = false;
                } finally {
                    this.submitting = false;
                }
            });
        },

        /* ===================== Hiệu ứng ===================== */
        // mưa “sọc”
        triggerStripeRainWithClouds() {
            const COUNT = 70;
            this.rainStripes = Array.from({ length: COUNT }).map(() => ({
                leftPct: Math.random() * 100,
                delayMs: Math.random() * 800,
                durMs: 1200 + Math.random() * 600,
                width: 1 + Math.random() * 1.2,
                height: 40 + Math.random() * 60
            }));
            this.rainActive = true;

            clearTimeout(this._rainTimer);
            this._rainTimer = setTimeout(() => {
                this.rainActive = false;
            }, 5000);
        },

        // mưa icon khóc khi 1-3 sao
        triggerCryingRain(level = 3) {
            // tạo item mưa
            const N = 100;
            this.cryRainItems = Array.from({ length: N }).map(() => ({
                leftPct: Math.random() * 100,
                delayMs: Math.random() * 400,
                durMs: 3500 + Math.random() * 1500,
                swayMs: 2400 + Math.random() * 1500,
                sizePx: 16 + Math.random() * 16
            }));
            this.cryRainActive = true;

            // tắt sau 5s
            setTimeout(() => (this.cryRainActive = false), 5000);

            // thêm mưa “sọc” nền cho kịch tính
            this.triggerStripeRainWithClouds();
        },

        /* ========= PHÁO HOA (4-5 SAO) — Promise resolve khi kết thúc ========= */
        triggerFireworks(level = 4) {
            // Bật confetti khi 5 sao
            this._confettiEnabled = level >= 5;

            // Trả về Promise để onSubmit() await
            return new Promise((resolve) => {
                // Nếu đã đang chạy, bắn thêm burst & gia hạn thời gian; reuse cùng Promise
                if (this.fireworksActive) {
                    if (this._spawnFireBurst) this._spawnFireBurst(level);
                    if (this._confettiEnabled && this._spawnConfetti) this._spawnConfetti(level);
                    clearTimeout(this._fwEndTimer);
                    this._fwEndTimer = setTimeout(() => this._stopFireworks(), 5000);
                    // Nếu chưa có resolver trước đó thì set
                    if (!this._fwResolve) this._fwResolve = resolve;
                    else resolve = this._fwResolve; // gộp vào promise đang chờ
                    return;
                }

                // Bắt đầu mới
                this.fireworksActive = true;
                this.$nextTick(() => {
                    this._startFireworks(); // init canvas + loop
                    if (this._spawnFireBurst) this._spawnFireBurst(level);
                    if (this._confettiEnabled && this._spawnConfetti) this._spawnConfetti(level);

                    // kết thúc sau 5s (auto)
                    clearTimeout(this._fwEndTimer);
                    this._fwEndTimer = setTimeout(() => this._stopFireworks(), 5000);

                    // Lưu resolver để gọi khi _stopFireworks
                    this._fwResolve = resolve;
                });
            });
        },

        _startFireworks() {
            const canvas = this.$refs.fireCanvas;
            if (!canvas) return;
            const ctx = canvas.getContext("2d");

            const resize = () => {
                canvas.width = window.innerWidth;
                canvas.height = window.innerHeight;
            };
            resize();

            const GRAVITY = 0.05;

            // Spawn theo cấp độ (4: vừa, 5: nhiều)
            this._spawnFireBurst = (level = 4) => {
                const bursts = level === 4 ? 3 : 5;
                for (let b = 0; b < bursts; b++) {
                    const x = Math.random() * canvas.width * 0.9 + canvas.width * 0.05;
                    const y = Math.random() * canvas.height * 0.4 + canvas.height * 0.1;
                    const count = 48 + (level - 4) * 24;
                    for (let i = 0; i < count; i++) {
                        const angle = (Math.PI * 2 * i) / count + Math.random() * 0.25;
                        const speed = 2.2 + Math.random() * 3.8;
                        const hue = Math.floor(Math.random() * 360);
                        this.fwParticles.push({
                            x, y,
                            vx: Math.cos(angle) * speed,
                            vy: Math.sin(angle) * speed,
                            life: 300 + Math.random() * 60,
                            alpha: 1,
                            color: `hsl(${hue}, 85%, 60%)`
                        });
                    }
                }
            };

            // Confetti cho 5 sao
            this._spawnConfetti = (level = 5) => {
                if (!this._confettiEnabled) return;
                const count = 120;
                for (let i = 0; i < count; i++) {
                    const x = Math.random() * canvas.width;
                    const y = -20 - Math.random() * 120;
                    const size = 4 + Math.random() * 6;
                    const length = 8 + Math.random() * 16;
                    const vx = (Math.random() - 0.5) * 1.2;
                    const vy = 2.2 + Math.random() * 2.2;
                    const rot = Math.random() * Math.PI * 2;
                    const rotSpeed = (Math.random() - 0.5) * 0.25;
                    const hue = Math.floor(Math.random() * 360);
                    this.confetti.push({
                        x, y, vx, vy, size, length,
                        rot, rotSpeed,
                        color: `hsl(${hue}, 90%, 55%)`,
                        life: 300
                    });
                }
            };

            // Loop vẽ
            const render = () => {
                ctx.clearRect(0, 0, canvas.width, canvas.height);

                // fireworks particles
                this.fwParticles.forEach((p) => {
                    p.x += p.vx;
                    p.y += p.vy;
                    p.vy += GRAVITY * 0.6;
                    p.life -= 1;
                    p.alpha = Math.max(0, p.life / 300);

                    ctx.globalAlpha = p.alpha;
                    ctx.fillStyle = p.color;
                    ctx.beginPath();
                    ctx.arc(p.x, p.y, 2.2, 0, Math.PI * 2);
                    ctx.fill();
                });
                for (let i = this.fwParticles.length - 1; i >= 0; i--) {
                    if (this.fwParticles[i].life <= 0 || this.fwParticles[i].alpha <= 0.02) this.fwParticles.splice(i, 1);
                }

                // confetti
                if (this._confettiEnabled) {
                    this.confetti.forEach((c) => {
                        c.x += c.vx;
                        c.y += c.vy;
                        c.vy += 0.015;
                        c.rot += c.rotSpeed;
                        c.life -= 1;
                        const alpha = Math.max(0, c.life / 300);

                        ctx.save();
                        ctx.globalAlpha = alpha;
                        ctx.translate(c.x, c.y);
                        ctx.rotate(c.rot);
                        ctx.fillStyle = c.color;
                        ctx.fillRect(-c.size / 2, -c.length / 2, c.size, c.length);
                        ctx.restore();
                    });
                    for (let i = this.confetti.length - 1; i >= 0; i--) {
                        if (this.confetti[i].life <= 0 || this.confetti[i].y > canvas.height + 30) this.confetti.splice(i, 1);
                    }
                }

                if (this.fireworksActive) this._fwAnim = requestAnimationFrame(render);
            };

            this._fwResizeHandler = resize;
            window.addEventListener("resize", this._fwResizeHandler);
            this._fwAnim = requestAnimationFrame(render);
        },

        _stopFireworks() {
            // stop loop + listeners
            if (this._fwAnim) cancelAnimationFrame(this._fwAnim);
            if (this._fwResizeHandler) {
                window.removeEventListener("resize", this._fwResizeHandler);
                this._fwResizeHandler = null;
            }
            this.fwParticles = [];
            this.confetti = [];

            // Ẩn canvas
            this.fireworksActive = false;

            // Resolve promise đang đợi (nếu có)
            if (typeof this._fwResolve === "function") {
                try { this._fwResolve(); } catch(_) {}
            }
            this._fwResolve = null;
            clearTimeout(this._fwEndTimer);
            this._fwEndTimer = null;
        }
    }
};
</script>

<style lang="scss" scoped>
.floating-btn {
    z-index: 1000;
    display: flex;
    align-items: center;
    position: absolute;
    bottom: 80px;
    left: 0;
    background: var(--color-tiny);
    padding: 10px 6px;
    border-radius: 0 10px 10px 0;
    cursor: pointer;
    font-size: 16px;
    width: 40px;
    overflow: hidden;
    transition: all 0.2s ease-in-out;
}

.custom-dialog {
    position: fixed;
    left: 10px;
    bottom: 20px;
    width: 420px;
    background: #fff;
    border-radius: 16px;
    box-shadow: 0 8px 24px rgba(0, 0, 0, 0.2);
    padding: 16px;
    z-index: 2000;
}

.btn-action { cursor: pointer; }
.btn-action:hover { color: var(--color-primary); }

.submit-rate {
    background-color: var(--color-primary) !important;
    border-color: var(--color-primary) !important;
}

.dialog-header {
    align-items: flex-start;
    display: flex;
    justify-content: space-between;
    gap: 12px;
    margin-bottom: 12px;
}
.dialog-header .left { display: flex; align-items: center; gap: 10px; }

.rate-row { display: inline-flex; align-items: center; gap: 10px; flex-wrap: nowrap; }
.rate-caption { display: inline-flex; align-items: center; gap: 8px; margin-top: 6px; }
.rate-text { line-height: 1.2; white-space: nowrap; }

.rate-icon { width: 32px; height: 32px; display: inline-block; transition: transform 120ms ease; }
.rate-icon:hover { transform: scale(1.08); }

/* Phóng to ngôi sao mặc định */
::v-deep(.el-rate__icon) { font-size: 25px !important; line-height: 1.3; }
.el-form-item { margin-bottom: 2px !important; }
.el-form-item__label { padding: 0 !important; }
::v-deep(.el-rate) { display: inline-flex; align-items: center; }

/* Khi hover vào dãy sao, sao active pop nhẹ */
::v-deep(.el-rate__icon.is-active) { animation: star-pop 220ms ease-out; }
::v-deep(.el-rate__item:hover .el-rate__icon) { transform: scale(1.12); transition: transform 120ms ease; }

.anim-shake {
    animation: shake-xy 900ms ease-in-out infinite;
    transform-origin: 50% 70%;
}
@keyframes shake-xy {
    0% { transform: translate(0, 0) rotate(0deg); }
    20% { transform: translate(-1px, 0) rotate(-7deg); }
    40% { transform: translate(1px, 0) rotate(6deg); }
    60% { transform: translate(-1px, 0) rotate(-5deg); }
    80% { transform: translate(1px, 0) rotate(4deg); }
    100% { transform: translate(0,0) rotate(0deg); }
}

.anim-bounce {
    animation: bounce-soft 1000ms ease-in-out infinite;
    transform-origin: 50% 100%;
}
@keyframes bounce-soft {
    0%, 100% { transform: translateY(0); }
    50% { transform: translateY(-3px); }
}

.anim-pop-once { animation: pop-once 250ms ease-out; }
@keyframes pop-once {
    0% { transform: scale(0.85); opacity: .8; }
    100% { transform: scale(1); opacity: 1; }
}
@keyframes star-pop { 0% { transform: scale(0.7); } 100% { transform: scale(1); } }

/* ====== MƯA ICON KHÓC ====== */
.cry-rain {
    position: fixed;
    inset: 0;
    pointer-events: none;
    z-index: 3500;
    overflow: hidden;
}
.cry-drop {
    position: absolute;
    top: -10vh;
    left: 0;
    animation-name: cry-fall, cry-sway, cry-fadeout;
    animation-timing-function: linear, ease-in-out, linear;
    animation-iteration-count: 1, infinite, 1;
    animation-duration: var(--dur, 5000ms), var(--sway, 3000ms), var(--dur, 5000ms);
}
@keyframes cry-fall {
    0%   { transform: translateY(-10vh); opacity: 0; }
    10%  { opacity: 1; }
    100% { transform: translateY(110vh); opacity: 1; }
}
@keyframes cry-sway {
    0%, 100% { transform: translateX(0); }
    50%      { transform: translateX(12px); }
}
@keyframes cry-fadeout {
    0%   { opacity: 1; }
    80%  { opacity: 1; }
    100% { opacity: 0; }
}

/* ====== Canvas pháo hoa full màn ====== */
.fireworks-canvas {
    position: fixed;
    inset: 0;
    z-index: 4000;
    pointer-events: none;
}
</style>
